export const BOOK_MODAL = 'bm';
export const LOGIN_MODAL = 'loginModal';
export const SHARE_MODAL = 'shareModal';
export const MARY_MAGIC_SURVEY_MODAL = 'maryMagicSurveyModal';
export const SAVE_SHOW_LOGIN_MODAL = 'save-and-then-show-login';
export const ADD_PROFILE_MODAL = 'add-profile-modal';
export const EDIT_PHARMACY_MODAL = 'edit-pharmacy-modal';
export const CALL_INSURANCE_MODAL = 'call-insurance-modal';
export const COPAY_EXPLANATION_MODAL = 'copay-explanation-modal';
